export default __webpack_public_path__ + "static/media/Radish.9b0555ff.jpg";